export const validate = values => {
    const errors = {};
    if (!values.password) errors.password = 'Required';
    if (!values.confirmPassword) errors.confirmPassword = 'Required';
    if (values.password !== values.confirmPassword)
        errors.confirmPassword = 'Password and confirm password must be the same';
    return errors;
};
